import moment from 'moment';
import { defaultConfigState } from './module-config-state';

export default {
	resetState(state) {
		//Object.assign(state, defaultConfigState);
	},
	updateConfig: function(state, payload) {
		let currentDate = moment(payload.CurrentDate).toDate();
		state.ConfigInfo = {
			...state.ConfigInfo,
			...payload,
			CurrentDate: currentDate,
			CurrentDateText: moment(currentDate).format('YYYY-MM-DD hh:mm:ss')
		};
	}
};
